/**
 * Customer edit — retired in favour of inline-edit section cards
 * on the detail page (`$customerId.index`). This route now just
 * redirects back to the detail page; the per-section dialogs there
 * (`features/customers/edit-dialogs/`) cover every field that lived
 * in the old monolithic edit form.
 *
 * Why we keep the file rather than delete: existing bookmarks,
 * outbound links from older surfaces, and the cover's `Edit`
 * button (until that's flipped to a popover trigger) still hit
 * this URL. A redirect keeps them working.
 *
 * @see $customerId.index.tsx — the inline-edit detail page
 */
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/(workspace)/sales/customers/$customerId/edit")({
  component: EditCustomerRedirect,
});

function EditCustomerRedirect() {
  const { customerId } = Route.useParams();
  return <Navigate to="/sales/customers/$customerId" params={{ customerId }} replace />;
}
